var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58942 7.51244L5.99512 8.39008L4.28666 9.17984L3.88096 8.30221L5.58942 7.51244Z",
    fill: "url(#paint0_linear_1082_31060)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72588 4.22852C9.18338 4.22852 10.3691 5.41428 10.3691 6.87177C10.3691 8.32927 9.18338 9.51503 7.72588 9.51503C6.26839 9.51503 5.08277 8.32927 5.08277 6.87177C5.08277 5.41428 6.26839 4.22852 7.72588 4.22852ZM7.72588 8.54798C8.65005 8.54798 9.40209 7.79609 9.40209 6.87177C9.40209 5.9476 8.6502 5.19556 7.72588 5.19556C6.80171 5.19556 6.04982 5.94746 6.04982 6.87177C6.04985 7.79594 6.80171 8.54798 7.72588 8.54798Z",
    fill: "url(#paint1_linear_1082_31060)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2236 0.537613C12.3345 0.537613 13.2383 1.44132 13.2383 2.55228C13.2383 3.66324 12.3346 4.56698 11.2236 4.56698C10.1128 4.56698 9.20892 3.66327 9.20892 2.55228C9.20892 1.44132 10.1126 0.537613 11.2236 0.537613ZM11.2236 3.59993C11.8012 3.59993 12.2712 3.12995 12.2712 2.55228C12.2712 1.97465 11.8012 1.50463 11.2236 1.50463C10.6459 1.50463 10.1759 1.97462 10.1759 2.55228C10.176 3.12995 10.6459 3.59993 11.2236 3.59993Z",
    fill: "url(#paint2_linear_1082_31060)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45506 0.972794C4.56602 0.972794 5.46973 1.8765 5.46973 2.98749C5.46973 4.09848 4.56602 5.00216 3.45506 5.00216C2.3441 5.00216 1.44036 4.09828 1.44036 2.98749C1.44036 1.87665 2.34407 0.972794 3.45506 0.972794ZM3.45506 4.03511C4.03269 4.03511 4.50271 3.56513 4.50271 2.98746C4.50271 2.4098 4.03272 1.93981 3.45506 1.93981C2.8774 1.93981 2.40741 2.4098 2.40741 2.98746C2.40741 3.56513 2.8774 4.03511 3.45506 4.03511Z",
    fill: "url(#paint3_linear_1082_31060)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3188 7.09743C14.4298 7.09743 15.3335 8.00113 15.3335 9.11212C15.3335 10.2231 14.4298 11.1268 13.3188 11.1268C12.208 11.1268 11.3041 10.2231 11.3041 9.11212C11.3041 8.00116 12.2079 7.09743 13.3188 7.09743ZM13.3188 10.1597C13.8965 10.1597 14.3665 9.68976 14.3665 9.1121C14.3665 8.53446 13.8965 8.06445 13.3188 8.06445C12.7412 8.06445 12.2712 8.53443 12.2712 9.1121C12.2712 9.68976 12.7412 10.1597 13.3188 10.1597Z",
    fill: "url(#paint4_linear_1082_31060)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64549 11.433C8.75645 11.433 9.66016 12.3367 9.66016 13.4477C9.66016 14.5586 8.75645 15.4624 7.64549 15.4624C6.53453 15.4624 5.63079 14.5587 5.63079 13.4477C5.63079 12.3367 6.5345 11.433 7.64549 11.433ZM7.64549 14.4953C8.22312 14.4953 8.69311 14.0253 8.69311 13.4477C8.69311 12.87 8.22312 12.4 7.64549 12.4C7.06783 12.4 6.59784 12.87 6.59784 13.4477C6.59784 14.0253 7.06783 14.4953 7.64549 14.4953Z",
    fill: "url(#paint5_linear_1082_31060)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68159 7.35529C3.79255 7.35529 4.69629 8.25899 4.69629 9.36998C4.69629 10.481 3.79258 11.3847 2.68159 11.3847C1.57077 11.3847 0.666922 10.4809 0.666922 9.36998C0.666922 8.25902 1.5706 7.35529 2.68159 7.35529ZM2.68159 10.4176C3.25925 10.4176 3.72924 9.94762 3.72924 9.36995C3.72924 8.79229 3.25925 8.32231 2.68159 8.32231C2.10396 8.32231 1.63394 8.79229 1.63394 9.36995C1.63394 9.94762 2.10393 10.4176 2.68159 10.4176Z",
    fill: "url(#paint6_linear_1082_31060)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92353 7.29525L12.0513 8.16556L11.6851 9.06069L9.5574 8.19037L9.92353 7.29525Z",
    fill: "url(#paint7_linear_1082_31060)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32341 8.98593L8.29004 9.01253L8.20934 11.9458L7.24271 11.9192L7.32341 8.98593Z",
    fill: "url(#paint8_linear_1082_31060)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94985 3.629L6.57764 4.82188L6.00601 5.60191L4.37823 4.40902L4.94985 3.629Z",
    fill: "url(#paint9_linear_1082_31060)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83504 3.38835L10.5801 4.00496L9.41953 5.40723L8.67449 4.79062L9.83504 3.38835Z",
    fill: "url(#paint10_linear_1082_31060)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1082_31060",
    x1: 5.14089,
    y1: 8.78496,
    x2: 4.73519,
    y2: 7.90733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1082_31060",
    x1: 10.3691,
    y1: 6.87177,
    x2: 5.08277,
    y2: 6.87177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1082_31060",
    x1: 13.2383,
    y1: 2.5523,
    x2: 9.20892,
    y2: 2.5523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1082_31060",
    x1: 5.46973,
    y1: 2.98748,
    x2: 1.44036,
    y2: 2.98748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1082_31060",
    x1: 15.3335,
    y1: 9.11211,
    x2: 11.3041,
    y2: 9.11211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1082_31060",
    x1: 9.66016,
    y1: 13.4477,
    x2: 5.63079,
    y2: 13.4477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1082_31060",
    x1: 4.69629,
    y1: 9.36997,
    x2: 0.666922,
    y2: 9.36997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1082_31060",
    x1: 11.8682,
    y1: 8.61312,
    x2: 9.74046,
    y2: 7.74281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1082_31060",
    x1: 8.24969,
    y1: 10.4792,
    x2: 7.28306,
    y2: 10.4526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1082_31060",
    x1: 6.29183,
    y1: 5.21189,
    x2: 4.66404,
    y2: 4.01901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1082_31060",
    x1: 9.9998,
    y1: 4.70609,
    x2: 9.25477,
    y2: 4.08948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C84E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F79"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.43b2dde261c843bbfae5fe01560a2b9f.svg";
export { ForwardRef as ReactComponent };